import {
    GenericTextInlineEditor,
    GenericTextInlineEditorProps,
} from 'components/inline_edit/GenericTextInlineEditor';
import { isValidNumber } from 'utils/number';

export type NumberInlineEditorProps = Omit<
    GenericTextInlineEditorProps<number>,
    'serialize' | 'deserialize'
>;

/**
 * Used to parse text input into a number.  No input will return undefined.
 */
export const deserialize = (input: string | undefined): number | undefined => {
    const trimmed = input?.trim();
    return trimmed ? Number(trimmed) : undefined;
};

export const serialize = (input: number | undefined) =>
    input === undefined || Number.isNaN(input) ? '' : input.toString();

export function NumberInlineEditor({ validate, ...rest }: NumberInlineEditorProps) {
    const validateNumber = (input: number | undefined) => {
        if (input !== undefined && !isValidNumber(input)) {
            return 'Value must be a valid number';
        }
        return validate?.(input);
    };

    return (
        <GenericTextInlineEditor<number>
            deserialize={deserialize}
            serialize={serialize}
            validate={validateNumber}
            {...rest}
        />
    );
}
